import React from "react";
import { Platform, View } from "react-native";
import {
  FlexGrid,
  theme,
  Accordion,
  Text,
  Heading,
} from "@clearabee/ui-library-native";
import { ids, styles } from "./AccountFAQs.styles";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { wordpressClient } from "lib/wordpress";
import { SkeletonLoader } from "components/SkeletonLoader/SkeletonLoader";
import { Rect } from "react-native-svg";

const isWeb = Platform.OS === "web";

export const AccountFAQs = (): React.ReactElement => {
  const [translate] = useTranslation();

  const { data: faqData, isLoading: faqLoading } = useQuery(
    "accountFaqs",
    wordpressClient.getAccountFAQs,
    { retry: 0 },
  );

  return (
    <View style={styles.container} dataSet={{ media: ids.container }}>
      <Accordion
        contentBackgroundColor={theme.colors.greyscale.lightest}
        buttonColor="light"
        iconColor="brand"
        singular
        styles={styles.accordionWrapper}
        dataSet={{ media: ids.accordionWrapper }}
      >
        <Text
          fontSize="xsmall2"
          color={isWeb ? "light" : "dark"}
          styles={[!isWeb && { fontFamily: "ProximaBold" }]}
        >
          {translate("hwa.components.accountFaq.subheading")}
        </Text>
        <Heading
          color={isWeb ? "accent" : "brand"}
          styles={{ marginVertical: theme.spacing.xsmall }}
          fontSize="base"
          level={5}
        >
          {translate("hwa.components.accountFaq.heading")}
        </Heading>
        <FlexGrid rowSpacing="xsmall">
          {faqLoading && (
            <FlexGrid.Cell base="100%">
              <SkeletonLoader
                speed={1}
                backgroundColor={theme.colors.light.base}
                foregroundColor={`${theme.colors.greyscale.lighter}00`}
                height={152}
                width="100%"
              >
                <Rect x="0" y="0" rx="8" ry="8" width="100%" height="40" />
                <Rect x="0" y="55" rx="8" ry="8" width="100%" height="40" />
                <Rect x="0" y="110" rx="8" ry="8" width="100%" height="40" />
              </SkeletonLoader>
            </FlexGrid.Cell>
          )}
          {!faqLoading &&
            faqData?.map(({ question, answer }, index: number) => (
              <FlexGrid.Cell key={question} base="100%">
                <Accordion.Item label={question} index={`${index}`} slim>
                  <Text fontSize="small">{answer}</Text>
                </Accordion.Item>
              </FlexGrid.Cell>
            ))}
        </FlexGrid>
      </Accordion>
    </View>
  );
};
